module.exports = __webpack_public_path__ + "bf405f92d27513c90018f2406ade9e6d.svg";